export default {
  search_comment_count:'评论',
  search_last_updated:'最新更新：',
  search_all_search:'全部搜索',
  search_little_video:'小视频',
  search_follow_count:'关注数',
  search_special_subject:'专题',
  search_invitation:'帖子',
  search_post:'贴子',
  search_search_word_after:'关于“{searchWordAfter}”的搜索结果',
  search_open_time:'开课时间：',
  search_score:"{score}分",
  search_pic_num:'共{smallImgList}张图片'
}
